import DataLayerHelper from '../../utils/datalayer-helper';
import FormField from './field';

export default class AccountID extends FormField {
    constructor(parent, el) {
        super(parent, el);
        this.input = this.inputs[0].el;
        this.populate();
    }

    populate() {
        this.parent.addEventListener('onSubmit', () => {
            const accountId = DataLayerHelper.getAccountId();
            this.input.value = accountId || '';
        });
    }

    static is(el) {
        return super.is(el) && el.classList.contains('form_field_account_id');
    }
}
